module.exports = __webpack_public_path__ + "static/media/image1.18092e3b.jpg";